import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, RouteProps, useHistory } from 'react-router-dom';
import { useIsPublicRouter } from '~/hooks/IsPublicRouter';
import { ApplicationState, store } from '~/store';

interface IProps extends RouteProps {
  component?: any;
  isPrivate?: boolean;
  isPublic?: boolean;
}

export default function RouteWrapper({
  component: Component,
  isPrivate = false,
  isPublic = false,
  ...rest
}: IProps) {
  const history = useHistory();
  const { handleIsPublicRouter } = useIsPublicRouter();
  const { signed } = store.getState().auth;

  const company = useSelector<ApplicationState, any>(
    state => state.auth.company,
  );

  if (isPublic) {
    handleIsPublicRouter(isPublic);
    return <Route {...rest} component={Component} />;
  }

  if (!signed && isPrivate) {
    history.push(`/${company?.path_alias_nm}`);
  }

  if (signed && !isPrivate) {
    return <Redirect to={`/${company?.path_alias_nm}/home`} />;
  }

  return <Route {...rest} component={Component} />;
}
